import sports from './sports.json';
import city from './city.json';
import foodAndDrinks from './foodanddrink.json';
import landscapes from './landscapes.json';

export const VOCABULARY_M8_U1 = [
...sports,
...city,
...foodAndDrinks,
...landscapes,
];